import React, { useEffect, useState, useCallback, useContext, useMemo } from 'react';
import { useDropzone } from "react-dropzone";
import PropTypes from 'prop-types';
import Client from '../../api/client';
import UserContext from '../../business/referential/UserContext';
import Styles from '../registration/styling/UploaderStyles';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';

function UpdateAccount({ currentRefresh, setRefresh }) {
    const [company, setCompany] = useState(null);
    const [firstname, setFirstName] = useState(null);
    const [lastname, setLastName] = useState(null);
    const [address, setAddress] = useState(null);
    const [zipcode, setZipCode] = useState(null);
    const [city, setCity] = useState(null);
    const [email, setEmail] = useState(null);
    const [filesProfil, setFilesProfil] = useState([]);
    const [userData, setUserData] = useState(null);
    const [clientObject, setClientObject] = useState(null);
    const ctx = useContext(UserContext);
    const [pageId, setPageId] = useState(34);

    const getContent = (key) => {
        if (userData) {
            if (userData.dataContent[pageId][key]) {
                return userData.dataContent[pageId][key].contentTxt;
            }
        }
        return '';
    }

    useEffect(() => {

        const process = async () => {
            Promise.resolve(ctx).then(value => {
                setUserData(value);
            });

            if (sessionStorage.getItem("controlPanel")) {
                var data = JSON.parse(sessionStorage.getItem("controlPanel"));
                setClientObject(data);
                setCompany(data.clientObject.societe);
                setFirstName(data.clientObject.nom);
                setLastName(data.clientObject.prenom);
                setAddress(data.clientObject.adresse);
                setZipCode(data.clientObject.cp);
                setCity(data.clientObject.ville);
                setEmail(data.clientObject.setEmail);
            }
        }

        process();

        return () => {
            filesProfil.forEach(file => URL.revokeObjectURL(file.preview));
        };
    }, []);

    const focusedStyle = {
        borderColor: '#2196f3'
    };

    const acceptStyle = {
        borderColor: '#00e676'
    };

    const rejectStyle = {
        borderColor: '#ff1744'
    };

    const onDropProfil = useCallback(acceptedFiles => {
        setFilesProfil(acceptedFiles.map(file => Object.assign(file, {
            preview: URL.createObjectURL(file)
        })));
    }, []);

    const { getRootProps: getRootPropsProfil, getInputProps: getInputPropsProfil, isFocused: isFocused1, isDragAccept: isDragAccept1, isDragReject: isDragReject1 } =
        useDropzone({ onDrop: onDropProfil, maxFiles: 1 });

    const style1 = useMemo(() => ({
        ...(isFocused1 ? focusedStyle : {}),
        ...(isDragAccept1 ? acceptStyle : {}),
        ...(isDragReject1 ? rejectStyle : {})
    }), [
        isFocused1,
        isDragAccept1,
        isDragReject1
    ]);

    const thumbs = filesProfil.map(file => (
        file.preview &&
        <div style={Styles.thumb} key={file.name}>
            <div style={Styles.thumbInner}>
                <img
                    src={file.name.match(/\.(jpg|jpeg|png|gif)$/) ? file.preview : "/assets/img/userIcon.svg"}
                    style={Styles.img}
                    // Revoke data uri after image is loaded
                    onLoad={() => { URL.revokeObjectURL(file.preview) }}
                />
            </div>
        </div>
    ));

    const handleSubmit = (evt) => {
        evt.preventDefault();
        processSubmit();
    }

    const processSubmit = () => {
        const update = async () => {

            let fileProfil = {};

            //DO SUBMIT
            if (filesProfil.length > 0) {

                fileProfil.formFile = filesProfil[0];
            }

            let idc = userData.userObject.id;

            await Client.updateProfil(idc, company, firstname, lastname, address, zipcode, city, email, fileProfil.formFile).then(data => {
                if (data.data) {
                    if (data.data.statusCode && data.data.statusCode === 500) {
                        NotificationManager.error(getContent("PROFIL_ERROR"));
                        return;
                    }

                    const process = async () => {
                        await Client.getControlPanel(userData.userObject.id).then(result => {
                            if (result !== null) {
                                sessionStorage.setItem("controlPanel", result);
                                var data = JSON.parse(result);
                                setClientObject(data);
                                setRefresh(currentRefresh + 1);
                            }
                        });

                        NotificationManager.success(getContent("PROFIL_SUCCESS"));
                    }
                    process();
                }
                else {
                    NotificationManager.error(getContent("PROFIL_ERROR"));
                }
            });

        }
        update();
    }

    return (<>
        <div className="dashboard-container">
            <h3 className="mb-2">
                {getContent("TitleCustomerAccount")}
            </h3>
            <p className="md-4 mb-xl-5">{getContent("UpdateText")}</p>

            {<div {...getRootPropsProfil({ className: 'dropzone', style: style1 })} style={{ border: "none", cursor: "pointer" }}>
                <input {...getInputPropsProfil()} />
                <div className="dz-message dropzone-content" data-dz-message>
                    <img src="/assets/img/userIcon.svg" alt="" className="user-avatar mb-2" style={{ maxWidth: "120px" }} />
                    <p className="user-avatar-description">
                        {getContent("PROFIL_UPLOADRULE")}
                    </p>
                    <svg className="me-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.5183 5.58668H16.4268L15.4805 3.69401C15.2701 3.27343 14.8286 3 14.3449 3H9.63411C9.15044 3 8.70873 3.27344 8.49854 3.69401L7.5522 5.58668H4.46057C3.09366 5.58668 2 6.6803 2 8.02625V17.532C2 18.878 3.09362 19.9926 4.46057 19.9926H19.5394C20.8854 19.9926 22 18.899 22 17.532V8.02625C21.979 6.6803 20.8854 5.58668 19.5185 5.58668H19.5183ZM11.9894 16.5646C9.76021 16.5646 7.97259 14.756 7.97259 12.5478C7.97259 10.3186 9.76025 8.53095 11.9894 8.53095C14.2186 8.53095 16.0062 10.3396 16.0062 12.5478C16.0062 14.777 14.2186 16.5646 11.9894 16.5646Z" fill="#0759E4" />
                    </svg>
                    {getContent("PROFIL_CHANGEPHOTO")}
                </div>
                <aside style={Styles.thumbsContainer}>
                    {thumbs}
                </aside>
            </div>
            }

            {/*<div className="user-change-btn-group d-flex justify-content-between justify-content-md-center mb-4">
                <button className="btn btn-outline-blue flex-grow-1 flex-lg-grow-0">
                    <svg className="me-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.4761 3H12.2417C9.08966 3.10412 6.66715 5.78719 6.66715 8.93925V10.8148H6.53687C5.67724 10.8148 5 11.492 5 12.3517V19.4631C5 20.3228 5.67724 21 6.53687 21H18.3373C19.1969 21 19.8741 20.3228 19.8741 19.4631L19.8743 12.3517C19.8743 11.492 19.1971 10.8148 18.3374 10.8148H18.2853V8.78295C18.2853 5.60493 15.6802 3 12.4761 3ZM13.5702 17.6918C13.5962 17.8743 13.4661 18.0305 13.2837 18.0305L12.424 18.0303H11.5644C11.382 18.0303 11.2519 17.8741 11.2778 17.6916L11.6165 16.0766C11.304 15.7901 11.0956 15.3733 11.1737 14.9045C11.2519 14.3573 11.7209 13.9145 12.2678 13.8364H12.4241C13.1274 13.8364 13.7005 14.4095 13.7005 15.1129C13.7005 15.5035 13.5181 15.8682 13.2317 16.1028L13.5702 17.6918ZM15.7323 10.8148H9.19391V8.8871C9.19391 7.19399 10.4442 5.68308 12.1375 5.52683C12.2417 5.52683 12.346 5.50085 12.4501 5.50085C14.2475 5.50085 15.7323 6.95956 15.7323 8.78302L15.7323 10.8148Z" fill="#0759E4" />
                    </svg>
                            Change Password
                        </button>
            </div>*/}
            {clientObject && <form className="dashboard-form" onSubmit={handleSubmit}>
                <div className="mb-2">
                    <label className="form-label">
                        <input type="text" className="form-control" placeholder={getContent("COL2")} disabled={true} onChange={v => setCompany(v.target.value)} defaultValue={clientObject.clientObject.societe} />
                    </label>
                </div>
                <div className="row g-2 mb-2">
                    <div className="col-12 col-lg-6">
                        <label className="form-label">
                            <input type="text" className="form-control" placeholder={getContent("COL3")} disabled={true} onChange={v => setFirstName(v.target.value)} defaultValue={clientObject.clientObject.nom} required />
                        </label>
                    </div>
                    <div className="col-12 col-lg-6">
                        <label className="form-label">
                            <input type="text" className="form-control" placeholder={getContent("COL4")} disabled={true} onChange={v => setLastName(v.target.value)} defaultValue={clientObject.clientObject.prenom} required />
                        </label>
                    </div>
                </div>
                <div className="mb-2">
                    <label className="form-label">
                        <input type="text" className="form-control" placeholder={getContent("COL5")} onChange={v => setAddress(v.target.value)} defaultValue={clientObject.clientObject.adresse} required />
                    </label>
                </div>
                <div className="row g-2 mb-2">
                    <div className="col-12 col-lg-6">
                        <label className="form-label">
                            <input type="text" className="form-control" placeholder={getContent("COL6")} onChange={v => setZipCode(v.target.value)} defaultValue={clientObject.clientObject.cp} required />
                        </label>
                    </div>
                    <div className="col-12 col-lg-6">
                        <label className="form-label">
                            <input type="text" className="form-control" placeholder={getContent("COL7")} onChange={v => setCity(v.target.value)} defaultValue={clientObject.clientObject.ville} required />
                        </label>
                    </div>
                </div>
                <div className="mb-2">
                    <label className="form-label">
                        <input type="email" className="form-control" placeholder={getContent("COL8")} disabled={true} onChange={v => setEmail(v.target.value)} defaultValue={clientObject.clientObject.email} required />
                    </label>
                </div>
                <button className="btn btn-blue">
                    {getContent("PROFIL_SAVE")}
                </button>
            </form>}
            <a href="/dashboard" className="arrow-back"></a>
        </div>
        <NotificationContainer />
    </>
    );
}

export default UpdateAccount;